import BulkUploadIncentiveMultipliersApi from "../../services/api/BulkUploadIncentiveMultipliers"
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload incentive multipliers:", err);
}

export const bulkUploadIncentiveMultipliers = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await BulkUploadIncentiveMultipliersApi.bulkUploadIncentiveMultipliers(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};